import axios from "axios";
import {
  removePost,
  setPostOnEdit,
  setPosts,
} from "../../Redux/Actions/postsActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ManagePosts = () => {
  const dispatch = useDispatch();

  const [posts, setPosters] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedUser = useSelector((state) => state.users.loggedUser);

  const isLoggedIn = loggedUser && Object.keys(loggedUser).length > 0;

  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }

    const fetchPosts = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const response = await axios.get(
          `https://api.arkiva.gov.al/api/posts?page=${currentPage}&limit=20`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const sortedPosts = response.data.posts.sort((a, b) => {
          const dateA = new Date(a.createdOn.split("/").reverse().join("-"));

          const dateB = new Date(b.createdOn.split("/").reverse().join("-"));

          return dateB - dateA;
        });

        setPosters(sortedPosts);

        setTotalPages(response.data.totalPages);

        dispatch(setPosts(sortedPosts));
      } catch (error) {
        console.error("Error fetching posts:", error);

        if (error.response?.status === 401) {
          navigate("/login");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [dispatch, isLoggedIn, navigate, currentPage]);

  if (!isLoggedIn) {
    return null;
  }

  const editPost = (post) => {
    dispatch(setPostOnEdit(post));

    navigate(`/manage/aktivitete/${post._id}`);
  };

  const addPost = () => {
    navigate("/manage/aktivitete/add-new");
  };

  const deletePost = async (post) => {
    const confirmDelete = window.confirm(
      `Jeni i sigurt që dëshironi të fshini "${post.title}"?`,
    );

    if (!confirmDelete) {
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.delete(
        `https://api.arkiva.gov.al/api/posts/delete/${post._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },

          data: {
            id: post.id,
          },
        },
      );

      if (response.data.message === "error") {
        alert("Something went wrong!");
        return;
      }

      setPosters((prevPosts) =>
        prevPosts.filter((item) => item._id !== response.data.postId),
      );

      dispatch(removePost(response.data.postId));
    } catch (error) {
      console.error("Error deleting post:", error);

      if (error.response?.status === 401) {
        alert("Sesioni ka skaduar. Ju lutem identifikohuni përsëri.");

        navigate("/login");
      } else if (error.response?.status === 403) {
        navigate("/unauthorized");
      } else {
        alert(
          error.response?.data?.message ||
            "Ndodhi një gabim gjatë fshirjes së postimit.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const filteredPosts = posts.filter((item) =>
    item.title.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button onClick={addPost}>
            <i className="fa-solid fa-plus"></i>
            Shto Aktivitet
          </button>
        </div>
      </div>

      <div className="manage-table">
        <table className="table">
          <thead>
            <tr>
              <th>Titulli</th>
              <th>Data</th>
              <th>Veprime</th>
            </tr>
          </thead>

          <tbody>
            {filteredPosts.length > 0 ? (
              filteredPosts.map((item) => (
                <tr key={item._id}>
                  <td data-label="Titulli">{item.title}</td>

                  <td data-label="Data">{item.createdOn}</td>

                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editPost(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>

                    <button onClick={() => deletePost(item)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Nuk u gjetën postime!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button
          className={`pagination-control-btn ${
            currentPage === 1 ? "disabled" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          &#8592; Para
        </button>

        <span className="pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className={`pagination-control-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          Pas &#8594;
        </button>
      </div>
    </div>
  );
};

export default ManagePosts;
